import { createBrowserRouter, lazy } from 'react-router-dom';

import HomePage, {loader as HomePageLoader} from '../home.page';

export const router = createBrowserRouter(
  [
    {
      element: <HomePage />,
      loader: HomePageLoader,
      children: [
        {
          path: '/',
          lazy: async () => {
            let { loader, Component } = await import ("../pages/selectLanguage.page");
            return { Component: Component, loader: loader}
          },
          index: true,
        },
        {
          path: 'wyloguj',
          lazy: async () => {
            let { loader, Component } = await import ("../pages/logout.page");
            return { Component: Component, loader: loader}
          },
        },
        {
          path: 'wychowanie-przedszkolne-test',
          lazy: async () => {
            let { loader, Component } = await import ("../pages/selectWpSeries.page");
            return { Component: Component, loader: loader}
          },
        },
        {
          path: ':language',
          lazy: async () => {
            let { loader, Component } = await import ("../pages/languageItemsList.page");
            return { Component: Component, loader: loader}
          },
        },
        {
          path: ':language/:level',
          lazy: async () => {
            let { loader, Component } = await import ("../pages/selectSeries.page");
            return { Component: Component, loader: loader}
          },
        },
        {
          path: ':language/:level/:book',
          lazy: async () => {
            let { loader, Component } = await import ("../pages/bookDetails.page");
            return { Component: Component, loader: loader}
          },
        }
      ]
    },
    {
      path: '/authorization',
      lazy: async () => {
        let { loader, Component } = await import ("../pages/login.page");
        return { Component: Component, loader: loader}
      },
    },
    {
      path: '/reset-password',
      lazy: async () => {
        let { loader, Component } = await import ("../pages/resetPassword.page");
        return { Component: Component, loader: loader}
      },
    }
  ]
);